/** Thrown when a stale/cancelled createPreview generation loses the race. */
export class PreviewCancelledError extends Error {
  readonly code = "PREVIEW_CANCELLED" as const;

  constructor(message = "Preview creation cancelled") {
    super(message);
    this.name = "PreviewCancelledError";
  }
}

export function isPreviewCancelledError(err: unknown): boolean {
  return (
    err instanceof PreviewCancelledError ||
    (typeof err === "object" &&
      err !== null &&
      (err as { code?: string }).code === "PREVIEW_CANCELLED")
  );
}
